<template>
  <div>
    <vs-popup-info-new-ver
      :active.sync="popupConfigNew.isOpen"
      :popupConfigNew="popupConfigNew"
      :key="index"
      @closePopup="closeCheckoutPopup"
    ></vs-popup-info-new-ver>
    <vs-popup
      fullscreen
      title="Appointment Information"
      :active.sync="config.isActive"
      id="pos-view-appointment-popup"
      @close="closePopup"
      :key="config.appointmentId"
    >
      <transition name="list">
        <div class="flex view-popup-content">
          <div
            class="lg:w-2/3 md:w-2/3 w-1/2 flex align-center flex-col overflow-auto"
          >
            <div class="flex flex-col justify-between h-full w-11/12">
                <div>
                <div>
                    <vs-chip
                        v-if="appointmentDetail.status !== undefined"
                        :color="statusColor(appointmentDetail.status)"
                        >{{ appointmentDetail.status.toUpperCase() }}</vs-chip
                    >
                    <br />
                    <p class="text-warning mt-5" v-if="appointmentDetail.status == 'done'">This transaction is already checked out</p>
                </div>
                <div class="flex align-center justify-between w-full">
                    <h3 class="font-light my-6 font-bold">
                        {{ appointmentDetail.date }}
                    </h3>
                    <!-- <vs-button
                        v-if="
                            appointmentDetail.status != 'done' &&
                            appointmentDetail.status != 'canceled' &&
                            appointmentDetail.service_booked &&
                            appointmentDetail.service_booked.length == 0
                        "
                        class="btn-calendar gradient gradient-primary no-shadow"
                        @click="editAppointment()"
                        style="padding: 0.75rem 2rem !important"
                    >
                        <i class="material-icons text-sm mr-1">create</i>Edit
                    </vs-button> -->
                </div>

                <div class="mb-6 pb-5">
                    <div class="vx-row mx-0 w-full" style="padding: 16px 0">
                    <div class="vx-col w-1/4 font-bold px-0">
                        {{ toAmPm(appointmentDetail.start_time) }} -
                        {{ toAmPm(appointmentDetail.end_time) }}
                    </div>
                    <div class="vx-col w-3/4 flex justify-between px-0">
                        <div>
                        <p
                            class="font-bold text-lg mb-2 p-0"
                            v-if="
                            appointmentDetail.service &&
                            appointmentDetail.service.name
                            "
                        >
                            {{ appointmentDetail.service.name }}
                        </p>
                        <p
                            class="text-sm pt-0"
                            v-if="
                            appointmentDetail.employee &&
                            appointmentDetail.employee.name
                            "
                        >
                            {{ appointmentDetail.duration.text }} with
                            {{ appointmentDetail.employee.name }}
                        </p>
                        </div>
                        <div class="font-bold text-lg">
                        <span>$</span>
                        <span>{{ appointmentDetail.price_final }}</span>
                        </div>
                    </div>
                    </div>
                    <!-- Additional -->
                    <div
                    class="vx-row mx-0"
                    style="padding: 16px 0"
                    v-for="appointment in appointmentDetail.additional_appointments"
                    :key="appointment.id"
                    >
                    <div class="vx-col w-1/4 font-bold px-0">
                        {{ toAmPm(appointment.start_time) }} -
                        {{ toAmPm(appointment.end_time) }}
                    </div>
                    <div class="vx-col w-3/4 flex justify-between px-0">
                        <div>
                        <p
                            class="font-bold text-lg mb-2"
                            v-if="appointment.service && appointment.service.name"
                        >
                            {{ appointment.service.name }}
                        </p>
                        <p
                            class="text-sm"
                            v-if="appointment.employee && appointment.employee.name"
                        >
                            {{ appointment.duration.text }} with
                            {{ appointment.employee.name }}
                        </p>
                        </div>
                        <div class="font-bold text-lg">
                        <span>$</span>
                        <span>{{ appointment.price_final }}</span>
                        </div>
                    </div>
                    </div>

                    <!-- Service booked old version -->
                    <div
                    class="vx-row mx-0"
                    style="padding: 16px 0"
                    v-for="appointment in appointmentDetail.service_booked"
                    :key="appointment.id"
                    >
                    <div class="vx-col w-1/4 font-bold px-0">
                        {{ toAmPm(appointmentDetail.start_time) }} -
                        {{ toAmPm(appointmentDetail.end_time) }}
                    </div>
                    <div class="vx-col w-3/4 flex justify-between px-0">
                        <div>
                        <p
                            class="font-bold text-lg mb-2"
                            v-if="appointment.service && appointment.service.name"
                        >
                            {{ appointment.service.name }}
                        </p>
                        <p
                            class="text-sm"
                            v-if="
                            appointment.service.duration &&
                            appointmentDetail.employee &&
                            appointmentDetail.employee.name
                            "
                        >
                            {{ appointment.service.duration }}m with
                            {{ appointmentDetail.employee.name }}
                        </p>
                        </div>
                        <div class="font-bold text-lg">
                        <span>$</span>
                        <span>{{
                            appointment.service.price
                            ? appointment.service.price
                            : 0
                        }}</span>
                        </div>
                    </div>
                    </div>

                    <vs-divider></vs-divider>

                    <div class="vx-row mx-0">
                    <div class="vx-col w-1/4 font-bold text-lg px-0"></div>
                    <div class="vx-col w-3/4 flex justify-between px-0">
                        <div>
                        <p class="text-lg mb-2 font-normal">
                            {{ totalDuration }}
                        </p>
                        </div>
                        <div class="font-bold text-xl">
                        <span>$</span>
                        <span>{{ totalPrice }}</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="appointment-history-detail">
                    <p
                    class="text-xl font-medium mb-2 font-bold"
                    v-if="appointmentDetail.note"
                    >
                    Appointment note
                    </p>
                    <p class="text-sm">{{ appointmentDetail.note }}</p>
                    <br />
                    <p
                    class="text-xl font-medium mb-2 font-bold"
                    @click="isShowHistory = !isShowHistory"
                    >
                    Appointment History
                    <feather-icon
                        v-if="!isShowHistory"
                        icon="ChevronDownIcon"
                        svgClasses="h-6 w-6"
                        class="mr-3"
                        style="transform: translateY(5px)"
                    />
                    <feather-icon
                        v-else
                        icon="ChevronUpIcon"
                        svgClasses="h-6 w-6"
                        class="mr-3"
                        style="transform: translateY(5px)"
                    />
                    </p>
                    <p class="text-sm pt-0">
                    Booked at {{ appointmentDetail.created_at }}
                    </p>
                    <p
                    hidden
                    class="text-sm pt-0"
                    v-if="appointmentDetail.updated_at != ''"
                    >
                    Last updated at {{ appointmentDetail.updated_at }}
                    </p>
                    <br />
                    <div v-if="isShowHistory">
                    <li
                        v-for="history in appointmentDetail.history"
                        :key="history.id"
                        class="text-sm pt-0"
                    >
                        Appointment status is set to
                        <b>{{ history.type.toUpperCase() }}</b>
                        at {{ history.created_at }}
                        <span v-if="history.staff_name">
                        by
                        <b>{{ history.staff_name }}</b>
                        </span>
                    </li>
                    </div>
                </div>
            </div>
          </div>

          <div class="lg:w-1/3 md:1/3 w-1/2 right-content">
            <div class="mini-scroll">
              <div
                class="flex flex-col align-center mb-3"
                style="height: 130px"
                v-if="appointmentDetail"
              >
                <vs-avatar
                  v-if="appointmentDetail.customer"
                  :text="
                    StringHelper.changeFormatAvatar(
                      appointmentDetail.customer.full_name
                    )
                  "
                  size="55px"
                  class="m-3 mt-0 text-2xl"
                />
                <vs-avatar
                  v-else
                  :text="
                    StringHelper.changeFormatAvatar(appointmentDetail.booker_name)
                  "
                  size="55px"
                  class="m-3 mt-0 text-2xl"
                />
                <p class="font-bold text-lg p-0 color-black">
                  {{ appointmentDetail.booker_name }}
                </p>
                <!-- <p class="text-sm">{{appointmentDetail.customer.phone}}</p> -->
                <div class="flex text-sm mt-3">
                  <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                  <span v-if="appointmentDetail.customer">{{
                    StringHelper.phoneNumberFormat(
                      appointmentDetail.customer.phone
                    )
                  }}</span>
                  <span v-else>{{
                    StringHelper.phoneNumberFormat(
                      appointmentDetail.booker_contact
                    )
                  }}</span>
                </div>
              </div>
              <!-- <vs-divider class="m-0 pl-4"></vs-divider> -->
              <!-- <div> -->
              <div
                :class="{
                  /*'appointment-done': appointmentDetail.status == 'done',*/
                }"
                class="overflow-auto view-appointment-tabs ml-4 border-bottom-custom"
              >
                <!-- <div class="flex flex-col align-center" v-if="appointmentDetail.status != 'done'">
                  <img src="../../assets/images/appointment/invoice.svg" class="svg-icon" />
                  <p class style="margin-bottom: 60px">No invoice issued yet</p>
                </div>
                <div class="flex flex-col align-center" v-else>
                  <img src="../../assets/images/appointment/invoice_done.svg" class="svg-icon" />
                  <p class style="margin-bottom: 60px">Appointment completed</p>
                </div>-->

                <appointment-tabs
                  v-if="appointmentDetail && appointmentDetail.customer"
                  :customerId="customerId"
                  :key="customerId"
                  :isFromPos="true"
                ></appointment-tabs>
              </div>
            </div>

            <!-- </div> -->
            <!-- <vs-divider class="m-0 p-0 pl-4"></vs-divider>  -->
            <div
              class="flex flex-col align-center pt-4 right-content-footer ml-4 mr-4"
            >
                <div class="w-full flex justify-between align-center font-bold pr-4 mb-1">
                    Sub Total:
                    <div>
                        <span class="ml-1">$0</span>
                    </div>
                </div>
                <div class="w-full flex justify-between align-center font-bold pr-4 mb-1">
                    Gift Card Price:
                    <div>
                        <span class="ml-1">$0</span>
                    </div>
                </div>
                <div class="w-full flex justify-between align-center font-bold pr-4 mb-1">
                    TIP:
                    <div>
                        <span class="ml-1">$0</span>
                    </div>
                </div>
                <div class="w-full flex justify-between align-center font-bold pr-4 mb-1">
                    Promotion:
                    <div>
                        <span class="ml-1">-$0</span>
                    </div>
                </div>
                <div class="w-full flex justify-between align-center font-bold pr-4 mb-1">
                    Redeem:
                    <div>
                        <span class="ml-1">-$0</span>
                    </div>
                </div>
                <div class="w-full flex justify-between align-center font-bold pr-4 mb-1">
                    Cash Discount:
                    <div>
                        <span class="ml-1">-$0</span>
                    </div>
                </div>
                <div class="w-full flex justify-between align-center font-bold pr-4">
                    Total:
                    <div>
                        <span class="ml-1">$</span>
                        <span>{{totalPrice}}</span>
                        <span class="ml-1">({{totalDuration}})</span>
                    </div>
                </div>

              <div
                class="vx-row w-full pr-4"
                v-if="
                  appointmentDetail.status != 'done' &&
                  appointmentDetail.status != 'canceled'
                "
              >
                <!-- <vs-button
                  v-if="appointmentDetail.status == 'scheduled'"
                  class="gradient gradient-success no-shadow vx-col w-custom mx-auto ml-0"
                  @click="changeStatus('confirmed')"
                  >CONFIRM APPOINTMENT</vs-button
                >
                <vs-button
                  type="border"
                  color="danger"
                  v-if="appointmentDetail.status == 'scheduled'"
                  class="vx-col w-custom mx-auto mr-0"
                  @click="changeStatus('canceled')"
                  >CANCEL APPOINTMENT</vs-button
                >
                <vs-button
                  type="border"
                  color="danger"
                  class="vx-col w-full mx-auto mr-0"
                  @click="changeStatus('canceled')"
                  v-if="appointmentDetail.status == 'confirmed'"
                  style="height: 42px"
                  >CANCEL APPOINTMENT</vs-button
                >

                <vs-button
                  color="primary"
                  type="filled"
                  class="gradient gradient-primary font-bold sm:text-xs text-sm shadow-md vx-col w-full mt-4"
                  @click="openCheckout"
                  style="height: 42px"
                  v-if="
                    appointmentDetail.checkin_available == true &&
                    type != 'auto'
                  "
                  >EXPRESS CHECKOUT</vs-button
                >

                <vs-button
                  color="primary"
                  type="filled"
                  class="gradient gradient-primary font-bold shadow-md vx-col w-full mt-4"
                  @click="doneAppointment"
                  v-if="
                    appointmentDetail.checkin_available == false ||
                    type == 'auto'
                  "
                  style="height: 42px"
                  :disabled="!doneable"
                  >DONE APPOINTMENT</vs-button
                > -->
                <!-- <div class="w-1/3 pr-3">
                    <vs-button color="white" type="filled" class="text-primary text-2xl shadow-md vx-col w-full mx-auto py-2 px-2">TIP</vs-button>
                </div>
                <div class="w-1/3 px-1">
                    <vs-button color="white" type="filled" class="text-primary text-2xl shadow-md vx-col w-full mx-auto py-2 px-2">VOID</vs-button>
                </div>
                <div class="w-1/3 pl-3">
                    <vs-button color="white" type="filled" class="text-primary text-2xl shadow-md vx-col w-full mx-auto py-2 px-2">REFUND</vs-button>
                </div> -->
              </div>

              <div class="vx-row w-full pr-4">
                <!-- <vs-button color="primary" type="filled" style="height: 42px" class="gradient gradient-primary font-bold sm:text-xs text-sm shadow-md vx-col w-full mt-4"
                  v-if="appointmentDetail.status == 'done'" @click="viewOrderDetail">
                  VIEW ORDER DETAIL
                </vs-button> -->
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div>
        <transition name="list">
          <!-- <vs-checkout
          :appointmentDetail="appointmentDetail"
          v-show="openCheckout"
          :key="appointmentDetail.id"
          v-if="openCheckout"
          ></vs-checkout>-->
        </transition>
        <vs-prompt
          @accept="acceptAlert"
          :active.sync="activePrompt"
          accept-text="Confirm"
          color="danger"
          title="Confirmation"
        >
          <div class="con-exemple-prompt">
            Are you sure to cancel this appointment?
          </div>
        </vs-prompt>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { StringHelper } from "../../models/string_helper";
import moment from "moment";

export default {
  name: "pos-appointment-popup",
  components: {
    Datepicker,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        if (this.config.isActive) {
          document.body.classList.add("overflow-hidden");
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      },
    },
    appointmentDetail: {
      immediate: true,
      deep: true,
      handler() {
        if (this.appointmentDetail && this.appointmentDetail.customer) {
          this.customerId = this.appointmentDetail.customer.id;
        }
      },
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    closeCheckoutPopup() {
      (this.popupConfigNew.isOpen = false), this.doneAppointment();
    },
    editAppointment() {
      this.$emit("edit", this.appointmentDetail.id);
    },
    changeStatus(status) {
      if (status == "canceled") {
        this.activePrompt = true;
      } else {
        let form = {
          id: this.appointmentDetail.id,
          status: status,
        };
        this.$store
          .dispatch("appointment/UPDATE_STATUS", form)
          .then(async () => {
            await this.$store.dispatch("appointment/GET_APPOINTMENT_DETAIL", {
              id: this.appointmentDetail.id,
            });
            await this.$vs.notify({
              title: "Success",
              text:
                "Appointment status is updated to " +
                status.toUpperCase() +
                "!",
              color: "success",
              position: "top-left",
            });
            // this.closePopup();
          });
      }
    },
    doneAppointment() {
      let form = {
        id: this.appointmentDetail.id,
        status: "done",
      };
      this.$store.dispatch("appointment/UPDATE_STATUS", form).then(() => {
        this.$vs.notify({
          title: "Success",
          text: "Checkout appointment successfully!",
          color: "success",
          position: "top-left",
        });
        this.closePopup();
      });
    },
    openCheckout() {
      this.index++;
      this.config.isActive = false;
      // if (this.type == "auto") {
      //   this.popupConfig = {
      //     isOpen: true,
      //     item_info: this.appointmentDetail.checkin,
      //     fromAppointment: true
      //   };
      // } else {
      this.popupConfigNew = {
        isOpen: true,
        item_info: this.appointmentDetail.checkin,
        fromAppointment: true,
      };
      // }
    },
    toAmPm(data) {
      if (data !== undefined) {
        let hours = parseInt(data.split(":")[0]);
        let minutes = parseInt(data.split(":")[1]);
        let ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let start_text = hours + ":" + minutes + " " + ampm;
        return start_text;
      }
    },
    statusColor(status) {
      switch (status) {
        case "confirmed":
          return "#6610f2";
        case "scheduled":
          return "#007bff";
        case "delay":
          return "#fd7e14";
        case "done":
          return "#28a745";
        case "canceled":
          return "#DC3546";
      }
    },
    acceptAlert() {
      let form = {
        id: this.appointmentDetail.id,
        status: "canceled",
      };
      this.$store.dispatch("appointment/UPDATE_STATUS", form).then(() => {
        this.$vs.notify({
          title: "Success",
          text: "Cancel appointment successfully!",
          color: "success",
          position: "top-left",
        });
        this.closePopup();
      });
    },
    viewOrderDetail() {
      let object = {
        app: "pos-appointment",
        type: "click",
        action: "order-detail",
        data: {
          order_id: this.config.order_id
        },
      };
      if (typeof window.chrome.webview !== "undefined") {
        window.chrome.webview.postMessage(object);
      }
      this.closePopup();
    }
  },
  computed: {
    appointmentDetail() {
      return this.$store.getters["posAppointment/appointmentDetail"];
    },
    totalPrice() {
      let total = 0;
      if (this.appointmentDetail.service) {
        let temp_price = parseInt(this.appointmentDetail.service.price);
        if (!isNaN(temp_price)) {
          total += temp_price;
        }
      }
      if (this.appointmentDetail.additional_appointments) {
        for (
          let i = 0;
          i < this.appointmentDetail.additional_appointments.length;
          i++
        ) {
          if (this.appointmentDetail.additional_appointments[i].service) {
            let temp_price = parseInt(
              this.appointmentDetail.additional_appointments[i].service.price
            );
            if (!isNaN(temp_price)) {
              total += temp_price;
            }
          }
        }
      }
      return total;
    },
    totalDuration() {
      let total = 0;
      if (this.appointmentDetail.duration) {
        let temp_duration = parseInt(this.appointmentDetail.duration.value);
        if (!isNaN(temp_duration)) {
          total += temp_duration;
        }
      }
      if (this.appointmentDetail.additional_appointments) {
        for (
          let i = 0;
          i < this.appointmentDetail.additional_appointments.length;
          i++
        ) {
          if (this.appointmentDetail.additional_appointments[i].duration) {
            let temp_duration = parseInt(
              this.appointmentDetail.additional_appointments[i].duration.value
            );
            if (!isNaN(temp_duration)) {
              total += temp_duration;
            }
          }
        }
      }
      let hours = Math.floor(total / 60);
      let minutes = total % 60;
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes}m`;
    },
  },
  data() {
    return {
      customerId: null,
      StringHelper,
      index: this.config.appointmentId + 1000,
      activePrompt: false,
      isShowHistory: false,
      popupConfigNew: {
        isOpen: false,
        item_info: {},
      },
      popupConfig: {
        isOpen: false,
        item_info: {},
      },
      type: "",
      doneable: true,
      // checkout_key: 0
    };
  },
  created() {
    if (
      typeof this.appointmentDetail !== "undefined" &&
      Object.keys(this.appointmentDetail).length > 0
    ) {
      let appointmentEndTime = this.appointmentDetail.end_time;
      let appointmentEndDate = this.appointmentDetail.date;
      if (
        typeof this.appointmentDetail.additional_appointments !== "undefined" &&
        this.appointmentDetail.additional_appointments
      ) {
        for (
          let i = 0;
          i < this.appointmentDetail.additional_appointments.length;
          i++
        ) {
          appointmentEndTime = this.appointmentDetail.additional_appointments[i]
            .end_time;
          appointmentEndDate = this.appointmentDetail.additional_appointments[i]
            .date;
        }
      }
      if (
        typeof appointmentEndDate !== "undefined" &&
        typeof appointmentEndTime !== "undefined"
      ) {
        this.doneable = moment().isAfter(
          appointmentEndDate + " " + appointmentEndTime
        );
      }
    }
    this.$store.dispatch("appSetting/GET_CHECKOUT_CONFIG").then(() => {
      let data = {};
      data = this.$store.state.appSetting.checkoutConfig;
      this.type = data.type;
    });
  },
};
</script>
